import {Component, DoCheck, OnInit} from '@angular/core';
import {AuthenticationService} from './services/authentication.service';
import {AccessService} from './services/access.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {EpasUtilService} from './services/epas-util.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import {Constants} from './constants';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [AuthenticationService]
})
export class AppComponent implements DoCheck, OnInit {
    title = 'Epas';
    user_name;
    selectUndefinedOptionValue = undefined;
    userRole;
    user;
    errorMessage: string;
    route;
    currentTime;
    now;
    timeToExpiry;
    activeRound: number;
    tokenExpiryTime;
    showTokenExpiry = false;
    isConnected: boolean = navigator.onLine;

    constructor(private router: Router,
                private accessService: AccessService,
                private authService: AuthenticationService,
                private utilService: EpasUtilService,
                private toastr: ToastrService) {
    }

    refreshTerm() {
        if (this.route.indexOf('login') === -1) {
            if (JSON.parse(localStorage.getItem('is_epas_logged_in')) === true) {
                if (JSON.parse(localStorage.getItem('epas_user')).hasOwnProperty('roles') &&
                    JSON.parse(localStorage.getItem('epas_user')).roles[0].role_name === Constants.OUTGOING_STUDENT) {
                    const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
                    this.utilService.refreshTerm(studentId)
                        .subscribe(
                            details => {
                                if (details.status === 'success') {
                                    /*this.utilService.term = details.data;
                                    if (details.data != null) {
                                        this.currentTime = details.data.current_time;
                                    }*/
                                    const user = JSON.parse(localStorage.getItem('epas_user'));
                                    user.term.rounds = details.data.rounds;
                                    this.utilService.term = {rounds: details.data.rounds};
                                    this.utilService.term.currentTime = details.data.current_time;
                                    this.utilService.term.registration_start_time = details.data.term.registration_start_time;
                                    this.utilService.term.registration_end_time = details.data.term.registration_end_time;
                                    this.authService.setUser(JSON.stringify(user));
                                } else if (details.status === 'fail' && details.data.name === 'SequelizeConnectionError') {
                                    Swal({type: 'error', title: 'There\'s a problem with your internet connection'});
                                } else {
                                    this.toastr.warning('Something is not right. Please refresh and reach out to contact team if' +
                                        ' the issue persists', 'Fail');
                                    this.errorMessage = details.data.message;
                                }
                            },
                            error => {
                                console.log(error);
                                this.toastr.warning('Something is not right. Please refresh and reach out to contact team if' +
                                    ' the issue persists', 'Fail');
                                this.errorMessage = 'Server Error';
                            });
                }
            }
        }
    }

    calculateTokenExpiryTime() {
        if (this.route.indexOf('login') === -1) {
            this.tokenExpiryTime = moment(localStorage.getItem('token_expiry_time')).utcOffset('+05:30');
            this.now = moment().utcOffset('+05:30');
            const diffDuration = this.tokenExpiryTime.diff(this.now);
            this.timeToExpiry = moment.duration(diffDuration);

            if (diffDuration < 0) {
                console.log('logout called in calculateTokenExpiryTime');
                this.authService.logout();
            } else if (diffDuration < 1800000) {
                this.showTokenExpiry = true;
            }
        }
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

    canAccessOutgoingStudent() {
        return this.accessService.canAccessOutgoingStudent();
    }

    /*canAccessExchangeCommittee() {
        return this.accessService.canAccessExchangeCommittee();
    }*/

    canAccessPOC() {
        return this.accessService.canAccessPOC();
    }

    canAccessIncomingStudent() {
        return this.accessService.canAccessIncomingStudent();
    }

    isLoggedIn(): boolean {
        return this.authService.isLoggedIn();
    }

    logout() {
        this.authService.logout();
    }

    refreshPage(): void {
        window.location.reload(true);
    }

    ngOnInit(): void {
        this.route = this.router.url;
        this.calculateTokenExpiryTime();
        if (this.timeToExpiry.hours() === 0 && this.timeToExpiry.minutes() <= 30) {
            this.showTokenExpiry = true;
            this.toastr.warning('Your token is about to expire in ' + this.timeToExpiry.minutes() +
                ' minutes, please logout and login again.', 'Session Expiry');
        } else {
            this.showTokenExpiry = false;
        }
        if (this.route.indexOf('login') === -1) {
            const semesterRefresh = setInterval(() => {
                this.refreshTerm();
            }, 30000);
        }
        this.isLoggedIn();
    }

    ngDoCheck() {
        this.isConnected = navigator.onLine;
        this.calculateTokenExpiryTime();
        if (this.isLoggedIn() === true) {
            this.user = this.authService.getUser();
            this.user_name = this.user.user_name;
            const userName = this.user_name.split('');
            if (userName.length > 10) {
                this.user_name = this.user_name.split('').splice(0, 15).join('') + '...';
            }
        }
    }
}


